import {
    GOALS,
    PROCESSES,
} from './editor.constants';
import { findIncomingCells } from './cell/automation-edge-utils';
import { findChildren } from './cell/automation-cell-utils';

// SANITIZER METHODS

// E-mail Confirm
const findEmailConfirmProcess = (cell, cells) => {
    try {
        const emailConfirmFlow = findIncomingCells(cell.id, cells)[0]; // email confirm goal always preceded by flow
        const emailConfirmChildren = findChildren(emailConfirmFlow.id, cells);

        return emailConfirmChildren.find((child) => child.meta.style === PROCESSES.PROCESS_EMAIL_CONFIRM);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Error in findEmailConfirmProcess', err);

        return null;
    }
};

const emailConfirmSanitizer = (cell, allCells) => {
    const emailConfirmProcess = findEmailConfirmProcess(cell, allCells);

    if (emailConfirmProcess) {
        const cellClone = { ...cell };

        cellClone.value = cellClone.value || {};
        cellClone.value.linkIds = [emailConfirmProcess.value.confirmLinkId];

        return cellClone;
    }

    return cell;
};

const cellValuePostCloneSanitizers = {
    [GOALS.GOAL_EMAIL_CONFIRM]: emailConfirmSanitizer,
};

export const sanitizeCellValue = (cell, allCells) => {
    // goals are referenced by meta type, processes by cell style
    const sanitizer = cellValuePostCloneSanitizers[cell?.meta?.style ?? cell?.meta?.metaType];

    return sanitizer ? sanitizer(cell, allCells) : cell;
};
